import { useEffect } from 'react'
import { useFlagStore } from 'stores/flagStore'
import { usePackageStore } from 'stores/packageStore'

function PackageLoader({ packageId }) {
  const loadPackage = usePackageStore((s) => s.loadPackage)
  const loadFlags = useFlagStore((s) => s.loadFlags)

  useEffect(() => {
    loadPackage(packageId)
  }, [packageId])

  useEffect(() => {
    const handler = () => {
      loadFlags(packageId)
      loadPackage(packageId)
    }
    document.addEventListener('package:document-uploaded', handler)
    return () => document.removeEventListener('package:document-uploaded', handler)
  }, [packageId, loadPackage, loadFlags])

  return null
}

export default PackageLoader
